module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "book_list_item clearFix",
    attrs: {
      "href": _vm.item.book_list_url || 'javascript:;'
    }
  }, [_c('div', {
    staticClass: "img_contain fl"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.book_attach_url),
      expression: "item.book_attach_url"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book_count"
  }, [_vm._v("共" + _vm._s(_vm.item.creation_count) + "本书")])]), _vm._v(" "), _c('div', {
    staticClass: "book_conent_title"
  }, [_c('p', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.item.book_title))]), _vm._v(" "), _c('div', {
    staticClass: "book_conent_title_bottom"
  }, [_vm._v(_vm._s(_vm.item.book_content))]), _vm._v(" "), _c('div', {
    staticClass: "comment_total"
  }, [_c('div', {
    staticClass: "hert",
    class: {
      collect_click: _vm.item.is_wish
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.wish_num))]), _vm._v(" "), _c('div', {
    staticClass: "comment_icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.comment_num))])])]), _vm._v(" "), (_vm.errobj.type) ? _c('popup', {
    attrs: {
      "pop-obj": _vm.errobj
    },
    on: {
      "confirm-click": _vm.confirmEvent
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fa93724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/booklistItem.vue
// module id = 218
// module chunks = 3